// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Heading-v{
  color:#fff;
  padding: 20px;
  font-size: 12px;
}
.headingtabs-v{
  display: flex;
 
  flex-direction: row;
}
.Subtabs-v{
  /* padding-left:20px; */
  color: rgba(115, 131, 149, 1);
  font-size: 16px;
  padding: 0px;
  margin-left: 20px;
  cursor: pointer;
}
.Subtabs-v.active{
  /* padding-left:20px; */
  color: #fff;
}
.Subtabs-v.active::after {
  content: "";
  display: block;
  height: 3px; /* Adjust the height of the underline as needed */
  width: 29px; /* Extend the underline to cover the tab width */
  background-color: #AD8BFF; /* Color of the underline */
  position: absolute;
}
.recommend-button-v{
  display: flex;
  flex-direction: row;
  float: left;
  
}
.recommend-text-v{
  color: #fff;
  padding: 15px;
  font-size: 14px;
  width: 200px;
}
.recommend-container {
  display: flex;
  flex-wrap: wrap;
  padding-top: 0;
}

.scrollable-content{
  max-height: 325px;
  overflow-x: hidden;
  /* max-height: 100%; */
  height: 5%;
}

.recommendation-column {
  background-color:#202342;
  
  margin: 3px;
  padding: 0px;
  /* height: 100px; */
  width: 500px;
  color: white;
  margin-left: 2px;
  margin-top: 3px;
  
  
  
}

.recommendation-column:nth-child(even){
  background-color: #202342;
}

.recommendation-column:nth-child(odd){
  background-color:rgba(173, 139, 255, 0.5%);
}



.recommendation-container{
  flex: 1 1;
}

.map-container{
  width: 100%; 
  height:100vh;
  position: absolute; 
  left: 570px; 
  margin-left: auto; 
  

 
}

.main-class-v{
  display: flex;
  flex-direction: row;
  width: 100%;
}

.recommendation-type-container{
display: inline-block;
font-size: 12px;
padding: 15px;

}

.recommendation-type-dropdown{
  font-size: 14px;
  margin-left: -30px;
background-color: #fff;
color:rgba(115, 131, 149, 1);
margin-top: -5px;
height: auto;
width: 150px;
}

.left-side-section2{
  height: 390px;
  border-bottom: 1px solid rgba(173, 139, 255, 0.2);
}

.generate-button-v{
border-radius: 25px;
background-color: #6B5CD1;
margin: 15px;
font-family: 'Graphik';
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 18px;
/* identical to box height */
text-align: center;
/* margin-top: 280px; */
/* border-top: 1px solid rgba(173, 139, 255, 0.2); */
width: 130px;
margin-left: 10px;
color: #FFFFFF;
border: 1px solid  #6B5CD1;
} 

.main-vegi-container{
display: flex;
flex-direction: column;
}

.left-section-vegitation { 
  margin-left: 20px;
}

.left-side{
box-shadow: 0 0 10px rgba(0,0,0,0.2);
margin-top: 5px;
/* margin-bottom: 5px; */
border-radius: 10px;
margin-right: 10px;
display: flex;
flex-direction: column;
background: rgba(0, 0, 0, 0.1);
position: absolute;
width: 500px;
 /* height: 375px; */
/* left: 80px; */
top: 150px;
max-height: 100%;
height: 72%;
margin-left: 10px;


background: rgba(0, 0, 0, 0.1);
border-radius: 15px;
}

.right-side{
position: absolute;
width: 530px;
/* height: 412px; */
left: 56%;
top: 150px;
overflow: hidden;
max-height: 100%;
height: 75%;
display: flex;
flex-direction: column;


}
#map{
width: 100%;
height:100%;
}

.left-side-section1{
border-right: 1px #ccc;
box-sizing: border-box;
position: relative;
border-bottom: 1px solid rgba(173, 139, 255, 0.2);
width: 100%;
}
/* .left-side-section1::after{
  content: "";
  display: block;
  border-bottom: 1px solid #AD8BFF;
  margin-top: 10px; 
  width: 500px;
  position: absolute;
} */



.box{
display:flex;
align-items: center;
width:auto;
}



.recommendation-row{
padding: 10px;
border: 1px solid #040466;

}

.priority-button{
/* padding: 3px 10px; */
/* border:color(from color srgb r g b); */
border-radius: 7px;
width: 70px;
height: 20px;
margin-left: 300PX;
margin-top: -45px;
}

.very-high-priority{
background-color: #FF3246;
color: white;
font-size: 12px;
text-align:center;
padding: 0;
border: 1px solid #FF3246;
border-radius: 7px;
width: 70px;
height: 20px;
}

.medium-priority{
background-color: #FF50A0;
color: white;
font-size: 12px;
text-align:center;
padding: 0;
border: 1px solid #FF50A0;
border-radius: 7px;
    width: 70px;
    height: 20px;
}

.low-priority{
background-color: #FF7800;
color: white;
font-size: 12px;
text-align:center;
padding: 0;
border: 1px solid #FF7800;
border-radius: 7px;
    width: 70px;
    height: 20px;
}

.Popup{
position:fixed;
top: 100%;
left: 20%;
width: 80%;
height: 90%;
background-color: #25304C;
display: flex;
align-items: center;
justify-content: center;
z-index: 999;
display: flex;
justify-content: center;

}

.popup-header{
display:flex;
justify-content: flex-end;
padding: 10px;
}

.popup-content {
background-color: white;
padding: 20px;
border-radius: 5px;
width: 100%;
height: 100%;
max-width: 600px; /* Adjust the max width as needed */
max-height: 400px; /* Adjust the max height as needed */
overflow-y: auto;
}

.close-button {
background: none;
border: none;
font-size: 24px;
cursor: pointer;
}

.recommmendation-cloumm-content2 {
  padding-left: 10px;
}

.sort-by-dropdown-v{
border-radius: 15px;
font-size: 10px;
background-color: rgba(173, 139, 255, 0.5);
color:#fff;
display: flex;
flex-direction: row;
width: auto;
height: 20px;
margin-top: 5px;
margin-left: 15px;
align-items: center;
line-height: 15px;
padding: 0px;
}

.filter-by-dropdown-v{
border-radius: 15px;
font-size: 12px;
border-color: #AD8BFF;
width: 17%;
height: 75%;
margin-top: 5px;
margin-left: 7px;
background-color: #202342;
color: white;
}

.substation-dropdown-v{
border-radius: 15px;
margin-top: 5px;
margin-left: 10px;
background: #202342;
color: white;
border-color: #AD8BFF;
height: 75%;
width: 85%;

}

.sort-by-button-v{
color: rgba(115, 131, 149, 1);
font-size: 12px;
display: flex;
padding-left: 20px;
flex-direction: row;
padding-top: 6px;
}

.filter-by-button-v{
color: rgba(115, 131, 149, 1);
font-size: 12px;
padding-top: 6px;
padding-left: 15px;
}

.substation-dropdown-v{
font-size: 12px;
margin-right: 10px;
margin-top: 5px;

}

.blur-background{
filter: blur(5px);

}

.popup-modal{
width: 80%;
height: 100%;
margin-left: 10%;
margin-right: 10%;
margin-top: 5%;
}

.priority-modal-content{
background-color: #202342;
color: #fff;
border-radius: 20px 20px 0px 0px;

}


.priority-modal-header {
padding: 10px 30px; 
color: #fff;
font-size: 16px;
}

.priority-modal-header h2 {
margin: 0; /* Remove default margin for the heading */
}

.popup-close-button {
background-color: transparent; 
border: none; 
cursor: pointer;
float: right;
font-size: 16px;
position: absolute;
top: 73px;
right: 160px;
color: #fff;
font-weight: 600;
}

.close-button:focus {
outline: none; 
}

.close-button:hover {
color: white;
}

.popup-main-container{
/* background-color:#202342; */
background-color: rgba(0, 0, 0, 0.1);
display: flex;
flex-direction: row;
width: 100%;
height:100%;
color:white;
/* border-radius: 0px 0px 20px 20px; */
}

.popup-leftside{
/* background-color: rgba(0, 0, 0, 0.1); */
      padding: 20px;
      min-width: 450px;
      display: flex;
      flex-direction: column;
      max-height: 500px;
      /* border-radius: 0px 0px 00px 20px; */
}

.popup-rightside{
      min-width: 500px;
      margin: 0px;
      /* max-height: 450px; */
      display: flex;
      flex-direction: column;
      padding: 0px;
      height:422px;
      margin-top: 20px;
      margin-left: 5px;
}

.mapshot-v{
height: 100%;
}

.smallpop-v{
width: 100%;
}

.container-1{
  background-color: rgba(173, 139, 255, 1.7%);
  height: 30%;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  padding-bottom: 5px;
}
.container-1-content-v{
  display: flex;
  flex-direction: row;
}

.image-towerpic-v{
  margin-left: 15px;
  height: 50px;
  margin-top: 7px;
  display: flex;
  flex-direction: column;
}

.container-1-image-v{
  display: flex;
  flex-direction: column;
}
.H1{
  display: flex;
  flex-direction: column;
  margin-left: 25px;
  font-size: 14px;
  margin-top: 10px;
  
}

.I1{
  display: flex;
  flex-direction: column;
  margin-top: 17px;
  margin-left: 75px;
}

.container-2{
width: 100%;
height: 40%;
margin-top: 10px;
background: rgba(173, 139, 255, 1.7%);
display: flex;
flex-direction: column;
margin-bottom: 5px;
padding-bottom: 5px;
}
.container-2-content{
padding-left: 3%;
font-size: 14px;

}


.container-3{
width: 100%;
height: 80%;
margin-top: 10px;
background:  rgba(173, 139, 255, 1.7%);
border-radius: 0px 0px 20px 20px;
margin-bottom: 5px;
padding-bottom: 5px;
}

.container-3-content{
font-size: 14px;
padding-left: 3%;
border-bottom-left-radius: 10px;


}

.end-pop{
display: flex;
flex-direction: row;
font-size: 8px;
padding-bottom: 5px;
text-transform: uppercase;
}
.D1{
font-size: 10px;
display: flex;
flex-direction: column;
padding-left: 15px;
padding-right: 20px;
}
.E1{
display: flex;
flex-direction: column;
margin-left: 15px;
font-size: 10px;
padding-right: 20px;
}

.F1{
font-size: 10px;
display: flex;
flex-direction: column;
margin-left: 15px;
padding-right: 20px;
}

.G1{
font-size: 10px;
display: flex;
flex-direction: column;
margin-left: 15px;
padding-right: 20px;
}

.underline-text{
  margin-top: 10px;
  padding-bottom: 5px;
  padding-left: 15px;
  width: 100%;
  border-bottom: 1px solid #AD8BFF;
}
.towerpic-v{
width: 80%;
padding-top: 25%;
padding-left: 10%;
}

/* .division-name {
  font-size: 12px;
} */

.recommmendation-cloumm-content{
 padding-left: 10px;
 margin: 0%;
 text-align: left;
 display: flex;
 flex-direction: column;
 font-size: 14px;
 width: 400px;
 padding-top: 10px;
}


.a1{
display: flex;
flex-direction: row;
}
.mid-pop{
display: flex;
flex-direction: row;
font-size: 8px;
padding-bottom: 5px;
}

.gap-row-popup {
  margin-top: 10px;
}

.A1{
display: flex;
flex-direction: column;
font-size: 10px;
padding-left: 15px;
}
.B1{
display: flex;
flex-direction: column;
font-size: 10px;
margin-left: 15px;
}
.C1{
display: flex;
flex-direction: column;
font-size: 10px;
margin-left: 15px;

}

.mid-pop-2{
display: flex;
flex-direction: column;
}

.recommend-a1-container-veg{
background: #202342;
flex-direction: row;
display: flex;
width: 500px;
height: 30px;
top: 333px;

}

.refreshicon-v{
height: 20px;


}
.refreshicon1{
display: flex;
flex-direction: row;
}

.circle-marker{
width: 20px;
height: 20px;
border-radius: 50%;
border: 2px solid #fff;
box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
cursor: pointer;
}

.mapboxgl-popup.custom-popup-v{
border: 2px #7500C0;
border-radius: 8px;
padding: 10px
}

.mapboxgl-popup.custom-popup-v::before{
border-bottom: 10px #7500C0;
}

.incident-loader-v{
  padding-top: 100px;
  padding-left: 40%;
  height: 286px;
}

.loader-text-v{
  color: #AD8BFF;
  font-size: 12px;
  font-weight: 450;
  margin-left: -30px;
}

.body-no-scroll {
  overflow: hidden;
}

.main-container-vegitation{
  height: 500px;
  
  width: 1150px;

}

.info-icon-v{
  cursor: pointer;
  height: 2px;
  width: 1%;
  text-align: center;
  padding-top: 10px;
  /* margin-left: 1030px; */
  /* margin-right: 10px; */
  float: right;
}

.i-icon-v{
  width: 25px;
  margin-top: 15px;
}



  

`, "",{"version":3,"sources":["webpack://./src/Vegitation.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;;EAEb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW,EAAE,iDAAiD;EAC9D,WAAW,EAAE,gDAAgD;EAC7D,yBAAyB,EAAE,2BAA2B;EACtD,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;;AAEb;AACA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,wBAAwB;;EAExB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;;;;AAIjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;;;AAIA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;;;;AAInB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;AACA,qBAAqB;AACrB,eAAe;AACf,aAAa;;AAEb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB,sBAAsB;AACtB,4BAA4B;AAC5B,gBAAgB;AAChB,YAAY;AACZ,YAAY;AACZ;;AAEA;EACE,aAAa;EACb,iDAAiD;AACnD;;AAEA;AACA,mBAAmB;AACnB,yBAAyB;AACzB,YAAY;AACZ,sBAAsB;AACtB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,4BAA4B;AAC5B,kBAAkB;AAClB,uBAAuB;AACvB,oDAAoD;AACpD,YAAY;AACZ,iBAAiB;AACjB,cAAc;AACd,0BAA0B;AAC1B;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;AACA,oCAAoC;AACpC,eAAe;AACf,wBAAwB;AACxB,mBAAmB;AACnB,kBAAkB;AAClB,aAAa;AACb,sBAAsB;AACtB,8BAA8B;AAC9B,kBAAkB;AAClB,YAAY;CACX,mBAAmB;AACpB,gBAAgB;AAChB,UAAU;AACV,gBAAgB;AAChB,WAAW;AACX,iBAAiB;;;AAGjB,8BAA8B;AAC9B,mBAAmB;AACnB;;AAEA;AACA,kBAAkB;AAClB,YAAY;AACZ,mBAAmB;AACnB,SAAS;AACT,UAAU;AACV,gBAAgB;AAChB,gBAAgB;AAChB,WAAW;AACX,aAAa;AACb,sBAAsB;;;AAGtB;AACA;AACA,WAAW;AACX,WAAW;AACX;;AAEA;AACA,sBAAsB;AACtB,sBAAsB;AACtB,kBAAkB;AAClB,iDAAiD;AACjD,WAAW;AACX;AACA;;;;;;;GAOG;;;;AAIH;AACA,YAAY;AACZ,mBAAmB;AACnB,UAAU;AACV;;;;AAIA;AACA,aAAa;AACb,yBAAyB;;AAEzB;;AAEA;AACA,uBAAuB;AACvB,yCAAyC;AACzC,kBAAkB;AAClB,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,iBAAiB;AACjB;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ,eAAe;AACf,iBAAiB;AACjB,UAAU;AACV,yBAAyB;AACzB,kBAAkB;AAClB,WAAW;AACX,YAAY;AACZ;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ,eAAe;AACf,iBAAiB;AACjB,UAAU;AACV,yBAAyB;AACzB,kBAAkB;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ,eAAe;AACf,iBAAiB;AACjB,UAAU;AACV,yBAAyB;AACzB,kBAAkB;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;AACA,cAAc;AACd,SAAS;AACT,SAAS;AACT,UAAU;AACV,WAAW;AACX,yBAAyB;AACzB,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB,YAAY;AACZ,aAAa;AACb,uBAAuB;;AAEvB;;AAEA;AACA,YAAY;AACZ,yBAAyB;AACzB,aAAa;AACb;;AAEA;AACA,uBAAuB;AACvB,aAAa;AACb,kBAAkB;AAClB,WAAW;AACX,YAAY;AACZ,gBAAgB,EAAE,mCAAmC;AACrD,iBAAiB,EAAE,oCAAoC;AACvD,gBAAgB;AAChB;;AAEA;AACA,gBAAgB;AAChB,YAAY;AACZ,eAAe;AACf,eAAe;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;AACA,mBAAmB;AACnB,eAAe;AACf,0CAA0C;AAC1C,UAAU;AACV,aAAa;AACb,mBAAmB;AACnB,WAAW;AACX,YAAY;AACZ,eAAe;AACf,iBAAiB;AACjB,mBAAmB;AACnB,iBAAiB;AACjB,YAAY;AACZ;;AAEA;AACA,mBAAmB;AACnB,eAAe;AACf,qBAAqB;AACrB,UAAU;AACV,WAAW;AACX,eAAe;AACf,gBAAgB;AAChB,yBAAyB;AACzB,YAAY;AACZ;;AAEA;AACA,mBAAmB;AACnB,eAAe;AACf,iBAAiB;AACjB,mBAAmB;AACnB,YAAY;AACZ,qBAAqB;AACrB,WAAW;AACX,UAAU;;AAEV;;AAEA;AACA,6BAA6B;AAC7B,eAAe;AACf,aAAa;AACb,kBAAkB;AAClB,mBAAmB;AACnB,gBAAgB;AAChB;;AAEA;AACA,6BAA6B;AAC7B,eAAe;AACf,gBAAgB;AAChB,kBAAkB;AAClB;;AAEA;AACA,eAAe;AACf,kBAAkB;AAClB,eAAe;;AAEf;;AAEA;AACA,iBAAiB;;AAEjB;;AAEA;AACA,UAAU;AACV,YAAY;AACZ,gBAAgB;AAChB,iBAAiB;AACjB,cAAc;AACd;;AAEA;AACA,yBAAyB;AACzB,WAAW;AACX,gCAAgC;;AAEhC;;;AAGA;AACA,kBAAkB;AAClB,WAAW;AACX,eAAe;AACf;;AAEA;AACA,SAAS,EAAE,0CAA0C;AACrD;;AAEA;AACA,6BAA6B;AAC7B,YAAY;AACZ,eAAe;AACf,YAAY;AACZ,eAAe;AACf,kBAAkB;AAClB,SAAS;AACT,YAAY;AACZ,WAAW;AACX,gBAAgB;AAChB;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,YAAY;AACZ;;AAEA;AACA,8BAA8B;AAC9B,oCAAoC;AACpC,aAAa;AACb,mBAAmB;AACnB,WAAW;AACX,WAAW;AACX,WAAW;AACX,sCAAsC;AACtC;;AAEA;AACA,0CAA0C;MACpC,aAAa;MACb,gBAAgB;MAChB,aAAa;MACb,sBAAsB;MACtB,iBAAiB;MACjB,sCAAsC;AAC5C;;AAEA;MACM,gBAAgB;MAChB,WAAW;MACX,uBAAuB;MACvB,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,gBAAgB;AACtB;;AAEA;AACA,YAAY;AACZ;;AAEA;AACA,WAAW;AACX;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;AACA,WAAW;AACX,WAAW;AACX,gBAAgB;AAChB,qCAAqC;AACrC,aAAa;AACb,sBAAsB;AACtB,kBAAkB;AAClB,mBAAmB;AACnB;AACA;AACA,gBAAgB;AAChB,eAAe;;AAEf;;;AAGA;AACA,WAAW;AACX,WAAW;AACX,gBAAgB;AAChB,sCAAsC;AACtC,gCAAgC;AAChC,kBAAkB;AAClB,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf,gBAAgB;AAChB,+BAA+B;;;AAG/B;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,cAAc;AACd,mBAAmB;AACnB,yBAAyB;AACzB;AACA;AACA,eAAe;AACf,aAAa;AACb,sBAAsB;AACtB,kBAAkB;AAClB,mBAAmB;AACnB;AACA;AACA,aAAa;AACb,sBAAsB;AACtB,iBAAiB;AACjB,eAAe;AACf,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf,aAAa;AACb,sBAAsB;AACtB,iBAAiB;AACjB,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf,aAAa;AACb,sBAAsB;AACtB,iBAAiB;AACjB,mBAAmB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;AAClC;AACA;AACA,UAAU;AACV,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;;GAEG;;AAEH;CACC,kBAAkB;CAClB,UAAU;CACV,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,YAAY;CACZ,iBAAiB;AAClB;;;AAGA;AACA,aAAa;AACb,mBAAmB;AACnB;AACA;AACA,aAAa;AACb,mBAAmB;AACnB,cAAc;AACd,mBAAmB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB,eAAe;AACf,kBAAkB;AAClB;AACA;AACA,aAAa;AACb,sBAAsB;AACtB,eAAe;AACf,iBAAiB;AACjB;AACA;AACA,aAAa;AACb,sBAAsB;AACtB,eAAe;AACf,iBAAiB;;AAEjB;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB;;AAEA;AACA,mBAAmB;AACnB,mBAAmB;AACnB,aAAa;AACb,YAAY;AACZ,YAAY;AACZ,UAAU;;AAEV;;AAEA;AACA,YAAY;;;AAGZ;AACA;AACA,aAAa;AACb,mBAAmB;AACnB;;AAEA;AACA,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,sBAAsB;AACtB,sCAAsC;AACtC,eAAe;AACf;;AAEA;AACA,mBAAmB;AACnB,kBAAkB;AAClB;AACA;;AAEA;AACA,2BAA2B;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;;EAEb,aAAa;;AAEf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".Heading-v{\r\n  color:#fff;\r\n  padding: 20px;\r\n  font-size: 12px;\r\n}\r\n.headingtabs-v{\r\n  display: flex;\r\n \r\n  flex-direction: row;\r\n}\r\n.Subtabs-v{\r\n  /* padding-left:20px; */\r\n  color: rgba(115, 131, 149, 1);\r\n  font-size: 16px;\r\n  padding: 0px;\r\n  margin-left: 20px;\r\n  cursor: pointer;\r\n}\r\n.Subtabs-v.active{\r\n  /* padding-left:20px; */\r\n  color: #fff;\r\n}\r\n.Subtabs-v.active::after {\r\n  content: \"\";\r\n  display: block;\r\n  height: 3px; /* Adjust the height of the underline as needed */\r\n  width: 29px; /* Extend the underline to cover the tab width */\r\n  background-color: #AD8BFF; /* Color of the underline */\r\n  position: absolute;\r\n}\r\n.recommend-button-v{\r\n  display: flex;\r\n  flex-direction: row;\r\n  float: left;\r\n  \r\n}\r\n.recommend-text-v{\r\n  color: #fff;\r\n  padding: 15px;\r\n  font-size: 14px;\r\n  width: 200px;\r\n}\r\n.recommend-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding-top: 0;\r\n}\r\n\r\n.scrollable-content{\r\n  max-height: 325px;\r\n  overflow-x: hidden;\r\n  /* max-height: 100%; */\r\n  height: 5%;\r\n}\r\n\r\n.recommendation-column {\r\n  background-color:#202342;\r\n  \r\n  margin: 3px;\r\n  padding: 0px;\r\n  /* height: 100px; */\r\n  width: 500px;\r\n  color: white;\r\n  margin-left: 2px;\r\n  margin-top: 3px;\r\n  \r\n  \r\n  \r\n}\r\n\r\n.recommendation-column:nth-child(even){\r\n  background-color: #202342;\r\n}\r\n\r\n.recommendation-column:nth-child(odd){\r\n  background-color:rgba(173, 139, 255, 0.5%);\r\n}\r\n\r\n\r\n\r\n.recommendation-container{\r\n  flex: 1;\r\n}\r\n\r\n.map-container{\r\n  width: 100%; \r\n  height:100vh;\r\n  position: absolute; \r\n  left: 570px; \r\n  margin-left: auto; \r\n  \r\n\r\n \r\n}\r\n\r\n.main-class-v{\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n}\r\n\r\n.recommendation-type-container{\r\ndisplay: inline-block;\r\nfont-size: 12px;\r\npadding: 15px;\r\n\r\n}\r\n\r\n.recommendation-type-dropdown{\r\n  font-size: 14px;\r\n  margin-left: -30px;\r\nbackground-color: #fff;\r\ncolor:rgba(115, 131, 149, 1);\r\nmargin-top: -5px;\r\nheight: auto;\r\nwidth: 150px;\r\n}\r\n\r\n.left-side-section2{\r\n  height: 390px;\r\n  border-bottom: 1px solid rgba(173, 139, 255, 0.2);\r\n}\r\n\r\n.generate-button-v{\r\nborder-radius: 25px;\r\nbackground-color: #6B5CD1;\r\nmargin: 15px;\r\nfont-family: 'Graphik';\r\nfont-style: normal;\r\nfont-weight: 400;\r\nfont-size: 14px;\r\nline-height: 18px;\r\n/* identical to box height */\r\ntext-align: center;\r\n/* margin-top: 280px; */\r\n/* border-top: 1px solid rgba(173, 139, 255, 0.2); */\r\nwidth: 130px;\r\nmargin-left: 10px;\r\ncolor: #FFFFFF;\r\nborder: 1px solid  #6B5CD1;\r\n} \r\n\r\n.main-vegi-container{\r\ndisplay: flex;\r\nflex-direction: column;\r\n}\r\n\r\n.left-section-vegitation { \r\n  margin-left: 20px;\r\n}\r\n\r\n.left-side{\r\nbox-shadow: 0 0 10px rgba(0,0,0,0.2);\r\nmargin-top: 5px;\r\n/* margin-bottom: 5px; */\r\nborder-radius: 10px;\r\nmargin-right: 10px;\r\ndisplay: flex;\r\nflex-direction: column;\r\nbackground: rgba(0, 0, 0, 0.1);\r\nposition: absolute;\r\nwidth: 500px;\r\n /* height: 375px; */\r\n/* left: 80px; */\r\ntop: 150px;\r\nmax-height: 100%;\r\nheight: 72%;\r\nmargin-left: 10px;\r\n\r\n\r\nbackground: rgba(0, 0, 0, 0.1);\r\nborder-radius: 15px;\r\n}\r\n\r\n.right-side{\r\nposition: absolute;\r\nwidth: 530px;\r\n/* height: 412px; */\r\nleft: 56%;\r\ntop: 150px;\r\noverflow: hidden;\r\nmax-height: 100%;\r\nheight: 75%;\r\ndisplay: flex;\r\nflex-direction: column;\r\n\r\n\r\n}\r\n#map{\r\nwidth: 100%;\r\nheight:100%;\r\n}\r\n\r\n.left-side-section1{\r\nborder-right: 1px #ccc;\r\nbox-sizing: border-box;\r\nposition: relative;\r\nborder-bottom: 1px solid rgba(173, 139, 255, 0.2);\r\nwidth: 100%;\r\n}\r\n/* .left-side-section1::after{\r\n  content: \"\";\r\n  display: block;\r\n  border-bottom: 1px solid #AD8BFF;\r\n  margin-top: 10px; \r\n  width: 500px;\r\n  position: absolute;\r\n} */\r\n\r\n\r\n\r\n.box{\r\ndisplay:flex;\r\nalign-items: center;\r\nwidth:auto;\r\n}\r\n\r\n\r\n\r\n.recommendation-row{\r\npadding: 10px;\r\nborder: 1px solid #040466;\r\n\r\n}\r\n\r\n.priority-button{\r\n/* padding: 3px 10px; */\r\n/* border:color(from color srgb r g b); */\r\nborder-radius: 7px;\r\nwidth: 70px;\r\nheight: 20px;\r\nmargin-left: 300PX;\r\nmargin-top: -45px;\r\n}\r\n\r\n.very-high-priority{\r\nbackground-color: #FF3246;\r\ncolor: white;\r\nfont-size: 12px;\r\ntext-align:center;\r\npadding: 0;\r\nborder: 1px solid #FF3246;\r\nborder-radius: 7px;\r\nwidth: 70px;\r\nheight: 20px;\r\n}\r\n\r\n.medium-priority{\r\nbackground-color: #FF50A0;\r\ncolor: white;\r\nfont-size: 12px;\r\ntext-align:center;\r\npadding: 0;\r\nborder: 1px solid #FF50A0;\r\nborder-radius: 7px;\r\n    width: 70px;\r\n    height: 20px;\r\n}\r\n\r\n.low-priority{\r\nbackground-color: #FF7800;\r\ncolor: white;\r\nfont-size: 12px;\r\ntext-align:center;\r\npadding: 0;\r\nborder: 1px solid #FF7800;\r\nborder-radius: 7px;\r\n    width: 70px;\r\n    height: 20px;\r\n}\r\n\r\n.Popup{\r\nposition:fixed;\r\ntop: 100%;\r\nleft: 20%;\r\nwidth: 80%;\r\nheight: 90%;\r\nbackground-color: #25304C;\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: center;\r\nz-index: 999;\r\ndisplay: flex;\r\njustify-content: center;\r\n\r\n}\r\n\r\n.popup-header{\r\ndisplay:flex;\r\njustify-content: flex-end;\r\npadding: 10px;\r\n}\r\n\r\n.popup-content {\r\nbackground-color: white;\r\npadding: 20px;\r\nborder-radius: 5px;\r\nwidth: 100%;\r\nheight: 100%;\r\nmax-width: 600px; /* Adjust the max width as needed */\r\nmax-height: 400px; /* Adjust the max height as needed */\r\noverflow-y: auto;\r\n}\r\n\r\n.close-button {\r\nbackground: none;\r\nborder: none;\r\nfont-size: 24px;\r\ncursor: pointer;\r\n}\r\n\r\n.recommmendation-cloumm-content2 {\r\n  padding-left: 10px;\r\n}\r\n\r\n.sort-by-dropdown-v{\r\nborder-radius: 15px;\r\nfont-size: 10px;\r\nbackground-color: rgba(173, 139, 255, 0.5);\r\ncolor:#fff;\r\ndisplay: flex;\r\nflex-direction: row;\r\nwidth: auto;\r\nheight: 20px;\r\nmargin-top: 5px;\r\nmargin-left: 15px;\r\nalign-items: center;\r\nline-height: 15px;\r\npadding: 0px;\r\n}\r\n\r\n.filter-by-dropdown-v{\r\nborder-radius: 15px;\r\nfont-size: 12px;\r\nborder-color: #AD8BFF;\r\nwidth: 17%;\r\nheight: 75%;\r\nmargin-top: 5px;\r\nmargin-left: 7px;\r\nbackground-color: #202342;\r\ncolor: white;\r\n}\r\n\r\n.substation-dropdown-v{\r\nborder-radius: 15px;\r\nmargin-top: 5px;\r\nmargin-left: 10px;\r\nbackground: #202342;\r\ncolor: white;\r\nborder-color: #AD8BFF;\r\nheight: 75%;\r\nwidth: 85%;\r\n\r\n}\r\n\r\n.sort-by-button-v{\r\ncolor: rgba(115, 131, 149, 1);\r\nfont-size: 12px;\r\ndisplay: flex;\r\npadding-left: 20px;\r\nflex-direction: row;\r\npadding-top: 6px;\r\n}\r\n\r\n.filter-by-button-v{\r\ncolor: rgba(115, 131, 149, 1);\r\nfont-size: 12px;\r\npadding-top: 6px;\r\npadding-left: 15px;\r\n}\r\n\r\n.substation-dropdown-v{\r\nfont-size: 12px;\r\nmargin-right: 10px;\r\nmargin-top: 5px;\r\n\r\n}\r\n\r\n.blur-background{\r\nfilter: blur(5px);\r\n\r\n}\r\n\r\n.popup-modal{\r\nwidth: 80%;\r\nheight: 100%;\r\nmargin-left: 10%;\r\nmargin-right: 10%;\r\nmargin-top: 5%;\r\n}\r\n\r\n.priority-modal-content{\r\nbackground-color: #202342;\r\ncolor: #fff;\r\nborder-radius: 20px 20px 0px 0px;\r\n\r\n}\r\n\r\n\r\n.priority-modal-header {\r\npadding: 10px 30px; \r\ncolor: #fff;\r\nfont-size: 16px;\r\n}\r\n\r\n.priority-modal-header h2 {\r\nmargin: 0; /* Remove default margin for the heading */\r\n}\r\n\r\n.popup-close-button {\r\nbackground-color: transparent; \r\nborder: none; \r\ncursor: pointer;\r\nfloat: right;\r\nfont-size: 16px;\r\nposition: absolute;\r\ntop: 73px;\r\nright: 160px;\r\ncolor: #fff;\r\nfont-weight: 600;\r\n}\r\n\r\n.close-button:focus {\r\noutline: none; \r\n}\r\n\r\n.close-button:hover {\r\ncolor: white;\r\n}\r\n\r\n.popup-main-container{\r\n/* background-color:#202342; */\r\nbackground-color: rgba(0, 0, 0, 0.1);\r\ndisplay: flex;\r\nflex-direction: row;\r\nwidth: 100%;\r\nheight:100%;\r\ncolor:white;\r\n/* border-radius: 0px 0px 20px 20px; */\r\n}\r\n\r\n.popup-leftside{\r\n/* background-color: rgba(0, 0, 0, 0.1); */\r\n      padding: 20px;\r\n      min-width: 450px;\r\n      display: flex;\r\n      flex-direction: column;\r\n      max-height: 500px;\r\n      /* border-radius: 0px 0px 00px 20px; */\r\n}\r\n\r\n.popup-rightside{\r\n      min-width: 500px;\r\n      margin: 0px;\r\n      /* max-height: 450px; */\r\n      display: flex;\r\n      flex-direction: column;\r\n      padding: 0px;\r\n      height:422px;\r\n      margin-top: 20px;\r\n      margin-left: 5px;\r\n}\r\n\r\n.mapshot-v{\r\nheight: 100%;\r\n}\r\n\r\n.smallpop-v{\r\nwidth: 100%;\r\n}\r\n\r\n.container-1{\r\n  background-color: rgba(173, 139, 255, 1.7%);\r\n  height: 30%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 5px;\r\n  padding-bottom: 5px;\r\n}\r\n.container-1-content-v{\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.image-towerpic-v{\r\n  margin-left: 15px;\r\n  height: 50px;\r\n  margin-top: 7px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.container-1-image-v{\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.H1{\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 25px;\r\n  font-size: 14px;\r\n  margin-top: 10px;\r\n  \r\n}\r\n\r\n.I1{\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-top: 17px;\r\n  margin-left: 75px;\r\n}\r\n\r\n.container-2{\r\nwidth: 100%;\r\nheight: 40%;\r\nmargin-top: 10px;\r\nbackground: rgba(173, 139, 255, 1.7%);\r\ndisplay: flex;\r\nflex-direction: column;\r\nmargin-bottom: 5px;\r\npadding-bottom: 5px;\r\n}\r\n.container-2-content{\r\npadding-left: 3%;\r\nfont-size: 14px;\r\n\r\n}\r\n\r\n\r\n.container-3{\r\nwidth: 100%;\r\nheight: 80%;\r\nmargin-top: 10px;\r\nbackground:  rgba(173, 139, 255, 1.7%);\r\nborder-radius: 0px 0px 20px 20px;\r\nmargin-bottom: 5px;\r\npadding-bottom: 5px;\r\n}\r\n\r\n.container-3-content{\r\nfont-size: 14px;\r\npadding-left: 3%;\r\nborder-bottom-left-radius: 10px;\r\n\r\n\r\n}\r\n\r\n.end-pop{\r\ndisplay: flex;\r\nflex-direction: row;\r\nfont-size: 8px;\r\npadding-bottom: 5px;\r\ntext-transform: uppercase;\r\n}\r\n.D1{\r\nfont-size: 10px;\r\ndisplay: flex;\r\nflex-direction: column;\r\npadding-left: 15px;\r\npadding-right: 20px;\r\n}\r\n.E1{\r\ndisplay: flex;\r\nflex-direction: column;\r\nmargin-left: 15px;\r\nfont-size: 10px;\r\npadding-right: 20px;\r\n}\r\n\r\n.F1{\r\nfont-size: 10px;\r\ndisplay: flex;\r\nflex-direction: column;\r\nmargin-left: 15px;\r\npadding-right: 20px;\r\n}\r\n\r\n.G1{\r\nfont-size: 10px;\r\ndisplay: flex;\r\nflex-direction: column;\r\nmargin-left: 15px;\r\npadding-right: 20px;\r\n}\r\n\r\n.underline-text{\r\n  margin-top: 10px;\r\n  padding-bottom: 5px;\r\n  padding-left: 15px;\r\n  width: 100%;\r\n  border-bottom: 1px solid #AD8BFF;\r\n}\r\n.towerpic-v{\r\nwidth: 80%;\r\npadding-top: 25%;\r\npadding-left: 10%;\r\n}\r\n\r\n/* .division-name {\r\n  font-size: 12px;\r\n} */\r\n\r\n.recommmendation-cloumm-content{\r\n padding-left: 10px;\r\n margin: 0%;\r\n text-align: left;\r\n display: flex;\r\n flex-direction: column;\r\n font-size: 14px;\r\n width: 400px;\r\n padding-top: 10px;\r\n}\r\n\r\n\r\n.a1{\r\ndisplay: flex;\r\nflex-direction: row;\r\n}\r\n.mid-pop{\r\ndisplay: flex;\r\nflex-direction: row;\r\nfont-size: 8px;\r\npadding-bottom: 5px;\r\n}\r\n\r\n.gap-row-popup {\r\n  margin-top: 10px;\r\n}\r\n\r\n.A1{\r\ndisplay: flex;\r\nflex-direction: column;\r\nfont-size: 10px;\r\npadding-left: 15px;\r\n}\r\n.B1{\r\ndisplay: flex;\r\nflex-direction: column;\r\nfont-size: 10px;\r\nmargin-left: 15px;\r\n}\r\n.C1{\r\ndisplay: flex;\r\nflex-direction: column;\r\nfont-size: 10px;\r\nmargin-left: 15px;\r\n\r\n}\r\n\r\n.mid-pop-2{\r\ndisplay: flex;\r\nflex-direction: column;\r\n}\r\n\r\n.recommend-a1-container-veg{\r\nbackground: #202342;\r\nflex-direction: row;\r\ndisplay: flex;\r\nwidth: 500px;\r\nheight: 30px;\r\ntop: 333px;\r\n\r\n}\r\n\r\n.refreshicon-v{\r\nheight: 20px;\r\n\r\n\r\n}\r\n.refreshicon1{\r\ndisplay: flex;\r\nflex-direction: row;\r\n}\r\n\r\n.circle-marker{\r\nwidth: 20px;\r\nheight: 20px;\r\nborder-radius: 50%;\r\nborder: 2px solid #fff;\r\nbox-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\r\ncursor: pointer;\r\n}\r\n\r\n.mapboxgl-popup.custom-popup-v{\r\nborder: 2px #7500C0;\r\nborder-radius: 8px;\r\npadding: 10px\r\n}\r\n\r\n.mapboxgl-popup.custom-popup-v::before{\r\nborder-bottom: 10px #7500C0;\r\n}\r\n\r\n.incident-loader-v{\r\n  padding-top: 100px;\r\n  padding-left: 40%;\r\n  height: 286px;\r\n}\r\n\r\n.loader-text-v{\r\n  color: #AD8BFF;\r\n  font-size: 12px;\r\n  font-weight: 450;\r\n  margin-left: -30px;\r\n}\r\n\r\n.body-no-scroll {\r\n  overflow: hidden;\r\n}\r\n\r\n.main-container-vegitation{\r\n  height: 500px;\r\n  \r\n  width: 1150px;\r\n\r\n}\r\n\r\n.info-icon-v{\r\n  cursor: pointer;\r\n  height: 2px;\r\n  width: 1%;\r\n  text-align: center;\r\n  padding-top: 10px;\r\n  /* margin-left: 1030px; */\r\n  /* margin-right: 10px; */\r\n  float: right;\r\n}\r\n\r\n.i-icon-v{\r\n  width: 25px;\r\n  margin-top: 15px;\r\n}\r\n\r\n\r\n\r\n  \r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
